import { ActionIcon, Group, MantineColor, Text } from '@mantine/core';
import { IconMinus, IconPlus, IconTrash } from '@tabler/icons-react';
import { MenuItemTemplate } from '@features/user/home/types';

interface CounterProps {
  value: number;
  min?: number;
  max?: number;
  tempId: string;
  onChange: (newCount: number, tempId: string) => void;
  hasTemplate?: boolean;
  template?: MenuItemTemplate;
  isDark?: boolean;
}

const Counter = ({
  value,
  max = Infinity,
  onChange,
  tempId,
  hasTemplate = false,
  template,
  isDark = false,
}: CounterProps) => {
  const buttonBgColor: MantineColor = 'var(--mantine-primary-color-9)';
  const buttonRadius: string = hasTemplate ? 'xl' : 'md';
  const isFullStack = hasTemplate && (template === 'grid' || template === 'zoom');

  const handleCountChange = (newCount: number) => {
    onChange(newCount, tempId);
  };

  const isTrash = value === 1;

  return (
    <Group justify="space-between" gap={hasTemplate ? '6px' : 'sm'}>
      <ActionIcon
        variant="filled"
        color={buttonBgColor}
        radius={buttonRadius}
        disabled={max === value}
        onClick={(e) => {
          e.stopPropagation();
          handleCountChange(value + 1);
        }}
        id="add_to_basket_plus"
      >
        <IconPlus size={hasTemplate ? '14px' : '1rem'} />
      </ActionIcon>

      <Text
        style={{
          borderRadius: '12px',
          flex: isFullStack ? 1 : 'initial',
          textAlign: 'center',
          minWidth: '34px',
          // eslint-disable-next-line no-nested-ternary
          background: hasTemplate && isDark ? '#3D3D3D' : hasTemplate && !isDark ? '#DFDFDF' : 'transparent',
        }}
      >
        {value}
      </Text>

      <ActionIcon
        variant="default"
        color={buttonBgColor}
        onClick={(e) => {
          e.stopPropagation();
          handleCountChange(value - 1);
        }}
        radius={buttonRadius}
        id="add_to_basket_minutes"
        {...(hasTemplate && { bg: 'transparent', style: { borderColor: '#212121' } })}
      >
        {isTrash ? <IconTrash size="1rem" /> : <IconMinus size="1rem" />}
      </ActionIcon>
    </Group>
  );
};

export default Counter;
